export default __webpack_public_path__ + "static/media/ps-chandelier.04859dbc.png";